import store from "@/store";
import { io } from "socket.io-client";

let socket = null;

const options = {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  autoConnect: false,
};

export function connect() {
  if (socket?.connected) {
    console.warn("⚠️ Socket já está conectado.");
    return socket;
  }

  if (!socket) {
    console.log("🟢 Criando nova conexão de socket...");
    socket = io(process.env.VUE_APP_SOCKET_URL, options);
    registerEvents(socket);
  }

  // atualiza o token de auth antes de conectar
  socket.auth = { token: store.getters.accessToken };

  if (!socket.connected && !socket.connecting) {
    socket.connect();
  }

  return socket;
}

export function disconnect() {
  if (socket) {
    socket.removeAllListeners(); // evita leaks de listeners
    socket.disconnect();
    socket = null; // libera instância
    console.log("🔴 Socket desconectado manualmente.");
  } else {
    console.warn("⚠️ Nenhum socket para desconectar.");
  }
}

export function getSocket() {
  if (!socket) {
    console.warn("⚠️ Socket ainda não foi inicializado, conectando...");
    return connect();
  }
  return socket;
}

function registerEvents(socket) {
  socket.on("connect", () => {
    console.log("✅ Socket conectado!");
  });

  socket.on("disconnect", (reason) => {
    console.log("⚡ Socket desconectado:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Erro de conexão:", err.message);
  });
}

export default {
  connect,
  disconnect,
  getSocket,
};
